import React from 'react';
import { injectIntl, intlShape } from '../../util/reactIntl';
import css from './LandingPage.module.css';
import Icons from '../../components/Icons/Icons';
import SectionHeroDesktopWaveSvg from './SectionHeroDesktopWaveSvg';
import SectionHeroMobileWaveSvg from './SectionHeroMobileWaveSvg';
import shape1 from '../../assets/landing/hero-shape-1.png';
import shape2 from '../../assets/landing/hero-shape-2.png';
import shape3 from '../../assets/landing/hero-shape-3.png';
import shape4 from '../../assets/landing/hero-shape-4.png';
import shape5 from '../../assets/landing/hero-shape-5.png';
import shape6 from '../../assets/landing/hero-shape-6.png';
import { isRtlLocale } from '../../util/genericHelpers';

const APP_STORE_URL = 'https://apps.apple.com/in/app/vivian-lab/id6758438180';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.vivian.lab';

function SectionHero({ intl, viewport }) {
  const locale = intl.locale || 'en';
  const isGreekLocale = locale === 'el';
  const rtl = isRtlLocale(locale);
  const isMobileLayout = viewport?.width > 0 && viewport?.width < 768;
  const title = intl.formatMessage({ id: 'LandingPage.SectionHero.title' });
  const subtitle = intl.formatMessage({ id: 'LandingPage.SectionHero.subtitle' });
  const appStoreLabel = intl.formatMessage({ id: 'LandingPage.SectionHero.appStore' });
  const googlePlayLabel = intl.formatMessage({ id: 'LandingPage.SectionHero.googlePlay' });
  const tryForFreeLabel = intl.formatMessage({ id: 'LandingPage.SectionHero.tryForFree' });
  const shapeAlt = intl.formatMessage({ id: 'LandingPage.SectionHero.shapeAlt' });

  return (
    <div className={css.heroContainer} dir={rtl ? 'rtl' : 'ltr'} data-testid="landing-hero">
      <span className={css.shape1}>
        <img src={shape1} alt={shapeAlt} />
      </span>
      <span className={css.shape2}>
        <img src={shape2} alt={shapeAlt} />
      </span>
      <span className={css.shape3}>
        <img src={shape3} alt={shapeAlt} />
      </span>
      <span className={css.shape4}>
        <img src={shape4} alt={shapeAlt} />
      </span>
      <span className={css.shape5}>
        <img src={shape5} alt={shapeAlt} />
      </span>
      <span className={css.shape6}>
        <img src={shape6} alt={shapeAlt} />
      </span>
      <div className={css.contentWidth}>
        <div className={css.heroContent}>
          <h1>{title}</h1>
          <p>{subtitle}</p>
          <div className={css.heroCtaGroup}>
            <div className={css.tryForFreeHeading}>{tryForFreeLabel}</div>
            <div className={css.buttonsContainer}>
              <a
                href={APP_STORE_URL}
                className={css.commonBtn}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icons name="applePlayStore" /> {appStoreLabel}
              </a>
              <a
                href={GOOGLE_PLAY_URL}
                className={css.commonBtn}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icons name="googlePlayStore" /> {googlePlayLabel}
              </a>
            </div>
          </div>
        </div>{' '}
        <div className={css.heroImg}></div>
      </div>

      <div className={css.waveWrap}>
        {isMobileLayout ? <SectionHeroMobileWaveSvg /> : <SectionHeroDesktopWaveSvg />}
      </div>
    </div>
  );
}

SectionHero.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(SectionHero);
